import { useContext } from 'react'
import { AnalyticsRegionCtx } from './AnalyticsRegionCtx'

export const useAnalytics = () => useContext(AnalyticsRegionCtx)
